import React from 'react';
import IconButton from '../basicComponents/IconButton';
import LanguageMenu from './LanguageMenu';
import MobileMenu from './MobileMenu';
import { useIcons, useLanguageItems } from '../../utils/hooks';

function Header({
	setRouting = () => {},
	portal,
	mobileMenuOptions = [],
	support,
	colors,
	translate,

	/* OPTIONAL PROPS */
	classNameDIV = 'relative flex w-full max-w-screen-2xl mx-auto font-lato space-x-6 justify-between align-middle',
	classNameBTN = 'w-52 z-50 h-12 md:h-24 md:w-auto ml-2 md:ml-9 mb-3 mt-7 focus:outline-none',
	classNameIMG = 'max-h-10 md:max-h-24',
}) {
	/* We save the items once calculated */ // className='invisible
	const { languageItems } = useLanguageItems({ portal, translate });

	/* Icon hook */
	const { BurguerMenu } = useIcons(colors);

	/* Default values for the styles */
	const defaultStyleDIV = {
		backgroundColor: colors?.background,
	};

	return <div id='Header'
		className={classNameDIV}
		style={defaultStyleDIV}
	>
		<IconButton
			classNameBTN={`${classNameBTN} ${!portal.config.header.logoIsActive && 'invisible'}`}
			classNameIMG={classNameIMG}
			icon={portal?.config?.header?.logo || portal?.council?.company?.logo}
			disabled={!portal?.config?.sections?.home?.isActive}
			onClick={() => setRouting('home')}
		/>
		{/* LANGUAGE MENU */}
		{portal?.config?.languages?.isActive && <LanguageMenu
			selected={languageItems?.find(element => element.key === translate.currentLanguage)}
			items={languageItems?.filter(element => element.key !== translate.currentLanguage)}
			colors={colors}
			displayType={portal?.config?.languages?.displayType}
		/>}
		{/* MOBILE MENU */}
		<MobileMenu
			MenuIcon={BurguerMenu}
			setRouting={setRouting}
			items={mobileMenuOptions}
			support={support}
			showLanguages={portal?.config?.languages?.isActive}
			languages={Object.values(portal?.config?.languages?.language || [])}
			translate={translate}
			colors={colors}
		/>
	</div>;
}


export default Header;
